module.exports = __webpack_public_path__ + "img/i_quest_LAND_off.f43c4bf.png";